module.exports = __webpack_public_path__ + "static/media/galerija_2022_0017.5b9cc950.jpg";